export default __webpack_public_path__ + "150680530af9dd9fd00bc70926302aed.ttf";